import Vimeo from '@vimeo/player';

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  const buttons = document.querySelectorAll('.hero-play, .break-play');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      // DOM is loaded and ready for manipulation here
      const modal = document.querySelector(
        `.videoModal[data-modal-video-id="${button.dataset.videoId}"]`,
      );
      const iframe = document.querySelector(
        `.videoModal[data-modal-video-id="${button.dataset.videoId}"] iframe`,
      );

      // Make sure elems exist before trying to use.
      if (!modal || !button || !iframe) {
        return;
      }

      const video = new Vimeo(iframe);
      const currentState = modal.style.display;
      const closeButtons = modal.querySelectorAll('.close-modal, .overlay');

      const closeModal = () => {
        modal.style.display = 'none';
        video.pause();
      };

      if (currentState === 'none') {
        modal.style.display = 'block';

        closeButtons.forEach(closeButton => {
          closeButton.addEventListener('click', closeModal);
        });

        video.play();
      } else {
        modal.style.display = 'none';

        closeButtons.forEach(closeButton => {
          closeButton.removeEventListener('click', closeModal);
        });

        video.pause();
      }
    });
  });
});
